import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb';

import { adminOrgActions } from '../../../../_actions/organisations/orgAdminList.action';
import CustomTableNew from '../../../../_components/common/CustomTableNew';
import ModalNew from '../../../../_components/common/ModalNew';
import { organisationAction } from '../../../../_actions/organisation.action';
import { manageBatchActions } from '../../../../_actions/organisations/manageBatchList.action';
import swal from 'sweetalert2';
import { toast } from 'react-toastify';


class primaryOrgDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            batchPermissionModal: false,
            checkBoxArr: [],
            sortTypeAdmin: false,
            orgAdminRow: {},


        }
    }

    componentDidMount() {

        this.props.dispatch(adminOrgActions.getAdminList(localStorage.getItem('seller_id'), localStorage.getItem('orgId')));
        this.props.dispatch(manageBatchActions.getBatchList({
            orgId: localStorage.getItem('orgId'),
            sellerId: localStorage.getItem('seller_id')
        }));
    }


    toggleEntireModal(showModal) {
        this.setState({
            batchPermissionModal: showModal,
        })

    }
    toggleModal(showModal) {
        this.setState({
            modal: showModal
        });
    }
    addOrgAdminAction(data) {
      
        
    }
    togglebatchPermissionModal(showModal) {
        this.setState({
            batchPermissionModal: showModal
        });
    }
    managePrimaryAdmin(key, data) {
        const { dispatch } = this.props;
       
        if (key.key === 'user_access__is_primary_admin') {
            swal({
                title: `Are you sure you want to Make ${data.full_name} as a Primary Admin?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.value) {
                    let sellerIdLocal = localStorage.getItem('seller_id')
                    dispatch(
                        organisationAction.makePrimaryAdmin({
                            "seller_id": this.state.sellerId,
                            "org_id": this.state.locationId,
                            "email": data.email
                        })
                    )
                    let toastId1 = toast['info'](`New Primary Admin is ${data.full_name}!`, {
                        position: toast.POSITION.BOTTOM_LEFT,
                        autoClose: 1500,
                    });

                    toast.update(toastId1, {
                        render: `New Primary Admin is ${data.full_name}!`,
                        type: toast.TYPE.INFO,
                        className: 'styleToastSuccess'
                    })
                }
            })
        } else if (key.key === '') {

            let checkBoxArr = []

            this.props.batchList !== '' &&
                this.props.batchList.map(val => {
                    let checkboxObj = {
                        key: val.batch_name,
                        type: 'checkbox',
                        value: false,
                        valid: true,
                        elementConfig: {
                            name: 'batch_code',
                            label: val.batch_name,
                        },
                        validation: {
                            required: false,
                            message: ""
                        },
                    }
                    checkBoxArr.push(checkboxObj)
                })

            data.batch_permission.map(value => {
                checkBoxArr.map(val => {
                    if (value.batch__batch_name === val.key) {
                        
                        val.value = true
                    }
                })
            })

            this.setState({
                orgAdminRow: data,
                checkBoxArr
            }, () => {
              
                if (this.props.batchList.length !== 0) {
                    this.togglebatchPermissionModal(true)
                }
                else {
                    swal({
                        text: "No Batch list to show",
                        type: "info",
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'OK'
                    })
                }
            })
        }
    }
    batchPermAdminAction(data) {
        const { dispatch } = this.props;
        let dataArr = [];

        for (const key in data.sellerData) {
            if (data.sellerData.hasOwnProperty(key)) {
                const element = data.sellerData[key];
                if (element === true) {
                    dataArr.push(key)
                }
            }
        }


       
        let properDataArr = []
        this.props.batchList.map(val => {
            dataArr.map(value => {
                val.batch_name === value &&
                    properDataArr.push(val)
            })
        })

        

        let batchIdArr = []

        properDataArr.map(val => {
            batchIdArr.push(val.id)
        })

        let dataObj = {
            "user_id": this.state.orgAdminRow.id,
            "batch_ids": batchIdArr
        }

        dispatch(organisationAction.batchPermissionAction({
            orgId: localStorage.getItem('orgId'),
            sellerId: localStorage.getItem('seller_id'),
            data: dataObj
        }))
    }



    sortBy(columnKey, type, tableName) {


        this.setState({ sortTypeAdmin: type })
        const arrayCopy2 = this.state.organisationAdminTable === '' ? this.props.admins : this.state.organisationAdminTable;
       
        this.setState({ organisationAdminTable: arrayCopy2 })
      



    }

    render() {
        const { orgAdmins } = this.props;

        const admins = [{
            name: 'FULL NAME',
            key: 'full_name',
            type: 'text',
            content: '',
            link: '',
            sort: true,
        },
        {
            name: 'EMAIL',
            key: 'email',
            type: 'text',
            content: '',
            link: '',
            sort: true,
        },
      
        {
            name: 'Batches',
            key: 'batch__batch_name',
            type: 'text',
            content: 'Batches',
            link: '',
        },
        {
            name: 'Batch Permission',
            buttonStatus: true,
            key: '',
            type: 'button',
            content: 'Batch Permission',
            link: '',
        },
        ]

        orgAdmins !== '' &&
            orgAdmins.map(val => {
                let attachString = ''
                if (val.batch_permission.length === 0) {
                    val.batch__batch_name = 'No Batches Selected!'
                } else {
                    val.batch_permission.map(value => {
                        if (attachString !== '') {
                            attachString = attachString + ', ' + value.batch__batch_name
                        } else {
                            attachString = value.batch__batch_name
                        }
                    })
                    val.batch__batch_name = attachString
                }
            })
        return (
            <div>
                <Navbar />
                <div className="container my-5" >

                    <div style={{ marginBottom: 20 }}>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'MANAGE BATCH PERMISSIONS'
                                }
                            ]}
                        />
                    </div>
                    <div className="bg-green rounded-top mt-5">
                        <p className="text-center text-uppercase py-2 text-white mb-0"> ORGANISATION ADMINS </p>
                    </div>


                    <CustomTableNew
                        data={orgAdmins}
                        columns={admins}
                        showSlNo="false"
                        checkbox="false"
                        buttonFunc={this.managePrimaryAdmin.bind(this)}
                      
                        textAlign="center"
                        sortBy={(key) => this.sortBy(key, !this.state.sortTypeAdmin, 'organisationAdminTable')}
                        sortType={this.state.sortTypeAdmin}
                    />
                    {
                        this.state.batchPermissionModal &&
                        <ModalNew
                            modalName="inlineOrgAdmin"
                            heading="ADD BATCH PERMISSION"
                            showModal={this.state.batchPermissionModal}
                            formData={this.state.checkBoxArr}
                            action={this.batchPermAdminAction.bind(this)}
                            toggleEntireModal={this.togglebatchPermissionModal.bind(this)}
                        />
                    }

                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
 
    const { error, loading } = state.organisationAdmins;
    const orgAdmins = (!error && !loading && (state.organisationAdmins.admins !== [])) ? state.organisationAdmins.admins : '';

   
    const { batch_list_error, batch_list_loading } = state.managaBatchList;
    const batchList = (!batch_list_error && !batch_list_loading) ? state.managaBatchList.batch_list.data.organisation_batch_list : '';
    return {
        orgAdmins,
        batchList,
    }
}
export default connect(mapStateToProps)(primaryOrgDetails);


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/PrimaryOrgAdmin/index.js